<template>
  <div>
    <multiselect
      v-model="inputValue"
      :options="options"
      @input="setValue"
      label="nome"
      track-by="id"
      :multiple="true"
      :placeholder="labelTitle"
      selectedLabel="«"
      deselectLabel=""
      selectLabel=""
    >
      <template slot="noResult" slot-scope="props">
        <span>{{ $t('Nenhum elemento encontrado.') }}</span>
      </template>
      <template slot="noOptions" slot-scope="props">
        <span>{{ $t('Nenhum dado foi retornado.') }}</span>
      </template>
      <template slot="tag" slot-scope="{ option, remove }">
        <span class="badge badge-primary mr-1">
          <span class="text-truncate mr-1 mb-1">
            {{ option.nome }}
          </span>
          <span class="custom__remove badge" @mousedown.prevent.stop="remove(option)"> x </span>
        </span>
      </template>
    </multiselect>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect
  },
  props: ['labelTitle', 'options', 'modelValue', 'allowEmpty'],
  emits: ['setValue'],
  data() {
    return {
      inputValue: this.modelValue
    };
  },
  computed: {
    customPlaceHolder() {
      return this?.labelTitle ? this.$i18n.t(this.labelTitle) : '';
    },
    isEmptySelectionAllowed() {
      return this.allowEmpty || false;
    }
  },
  mounted() {
    if (this.options?.length > 0) {
      this.inputValue = this.options[0];
    }
  },
  watch: {
    modelValue() {
      this.inputValue = this.modelValue;
    }
  },
  methods: {
    setValue() {
      this.$emit('setValue', this.inputValue);
    }
  }
};
</script>

<style lang="scss">
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
